<app-layout [class.dark-theme]="isDarkTheme">
    <mat-sidenav-container>
        <mat-sidenav #sidenav role="navigation" id="main-sidenav">
            <app-sidenav (sidenavClose)="sidenav.close()" [isAdmin]="isAdmin" [isSystemAdmin]="isSystemAdmin" [loginDisplay]="loginDisplay" [isTutor]="isTutor">
            </app-sidenav>
        </mat-sidenav>
        <mat-sidenav-content fxLayout="column" fxFlexFill>
            <app-header id="app-header-west" *ngIf="!checkIfMsalSignedInPage()" (sidenavToggle)="sidenav.toggle()" (toggleTheme)="toggleTheme()" [loginDisplay]="loginDisplay"
                (loggingout)="onProcessLogout()" (changingPassword)="changePassword()" [isAdmin]="isAdmin" [userDetail]="userHeaderDetails"></app-header>
            <main fxFlex="auto" fxFlex.md="none" fxFlex.sm="none" fxFlex.xs="none">
                <div *ngIf="isDisplayScreenLoader || onStartUpScreenLoader">
                    <app-loading-screen [onStartUp]="onStartUpScreenLoader"></app-loading-screen>
                </div>
                <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
                <router-outlet *ngIf="!isIframe" (activate)="onActivate($event)" (deactivate)="onDeactivate($event)">
                </router-outlet>
            </main>
            <app-footer *ngIf="!checkIfMsalSignedInPage()" [url]="prevUrl" fxFlexOffset.xs="100px" fxFlexOffset.sm="100px" fxFlexOffset="auto"></app-footer>
        </mat-sidenav-content>
    </mat-sidenav-container>
</app-layout>